import * as React from "react";

export interface ISectorSearchProps {
	oneBoxContent: {
		type: string;
		tab: string;
		action: string;
		data: {
			sec: string;
			stkDet: [];
		};
	};
}

export function SectorSearch(props: ISectorSearchProps) {
	return (
		<>
			<div id="obr" className="oneboxResults searchRes">
				<span className="AsearchHeader">
					{props.oneBoxContent.data.sec}
				</span>
				<span className="AsearchHeaderA">
					Top 5 Sector Constituents
				</span>
				<table className="table AtableSearch">
					<tbody>
						<tr>
							<td>Company Name</td>
							<td className="AtRight">LTP</td>
							<td className="AtRight">Change</td>
							<td className="AtRight">
								Market Cap
								<br />
								(in Cr)
							</td>
							<td className="AtRight">PE(x)</td>
						</tr>
						{props.oneBoxContent.data.stkDet.map(
							(comp: any, i: number) => (
								<tr>
									<td className="AtColBlue ATBold">
										<a href={comp.url}>{comp.nm}</a>
									</td>
									<td className="ATBold AtRight">
										{comp.ltp}
									</td>
									<td className="AtColGreenD ATBold AtRight">
										<span className="ed-red mg-110">
											{comp.chg +
												" (" +
												comp.chgP +
												" % )"}
										</span>
									</td>
									<td className="AtRight ATBold">
										{comp.mCap}
									</td>
									<td className="ATBold AtRight">
										{comp.pe}
									</td>
								</tr>
							)
						)}
					</tbody>
				</table>
			</div>
		</>
	);
}
